export class RoleFilters {
    vet: boolean;
    vetNurse: boolean;
    nonClinical: boolean;
    practiceContent: boolean;

    constructor(roleFilters?) {
      if (roleFilters) {
          this.vet = roleFilters.id || false;
          this.vetNurse = roleFilters.name || false;
          this.nonClinical = roleFilters.id || false;
          this.practiceContent = roleFilters.name || false;
      }
  }
}
